export default __webpack_public_path__ + "static/media/NotoSansKR-Black.25681076.ttf";